import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  styled,
  Divider,
  Box
} from '@mui/material';
import React from 'react';

import Icon from '../Icon';

import { ContentModalProps } from './types';

const Modal = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: `${theme.spacing(2)}  0px`,
    borderBottom: 0
  },
  '& .MuiDialogActions-root': {
    margin: 0
  },
  '& .MuiDialogTitle-root': {
    padding: 0,
    marginBottom: theme.spacing(2)
  }
}));

const ContentModal = ({ isOpen, handleClose, handleActions, children, title, show }: ContentModalProps) => {
  return (
    <Modal
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: theme => ({ p: theme.spacing(3), borderRadius: 3, minWidth: 300 }) }}
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle fontWeight={600} fontSize={18} id="alert-dialog-title">
        {title}
      </DialogTitle>
      <IconButton
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 16,
          top: 16,
          color: theme => theme.palette.grey[500],
          borderRadius: '4px',
          padding: '0'
        }}
      >
        <Icon name="close" size={'24'} />
      </IconButton>
      <DialogContent dividers>{children}</DialogContent>
      <Divider></Divider>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        {show && (
          <Button variant="outlined" size="medium" onClick={handleActions}>
            View Original
          </Button>
        )}
        {/* <Box width='100%' > */}
        <Button sx={{ display: 'flex', justifyContent: 'flex-end' }} size="medium" onClick={handleActions}>
          Save
        </Button>
        {/* </Box> */}
      </DialogActions>
    </Modal>
  );
};

export default ContentModal;
